(() => {
  const fields = ['title', 'body', 'product_type', 'tag', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];
  const groups = (document.getElementById('le-search-aliases')?.textContent || '').trim().split('\n')
    .map(line => line.split(',').map(word => word.trim().toLocaleLowerCase()).filter(Boolean));
  const tokenize = text => text.match(/[\p{L}\p{N}]+(?:[.'’_-][\p{L}\p{N}]+)*/gu) || [];
  const vocabulary = [...new Set(JSON.parse(document.getElementById('le-search-vocabulary')?.textContent || '[]')
    .flatMap(title => tokenize(title.toLocaleLowerCase())))];
  const isStructured = value => value.startsWith('(title:"') && value.includes('" OR body:"');
  const build = value => {
    const text = value.trim();
    if (isStructured(text)) return text;
    const words = tokenize(text);
    if (!words.length) return '(title:"le-no-search-term" OR body:"le-no-search-term")';
    return words.map(word => {
      const lower = word.toLocaleLowerCase();
      const exactAliases = groups.find(group => group.includes(lower));
      const prefixAliases = lower.length >= 3 ? groups.find(group => group.some(alias => alias.startsWith(lower))) : null;
      const aliases = exactAliases || prefixAliases || [];
      const completions = lower.length >= 3 && !vocabulary.includes(lower)
        ? vocabulary.filter(value => value.startsWith(lower)).slice(0, 8) : [];
      const values = [...new Set([word, ...aliases, ...completions])];
      return '(' + values.flatMap(value => fields.map(field => `${field}:"${value}"`)).join(' OR ') + ')';
    }).join(' AND ');
  };
  window.leSearch = { build, isStructured };
  if (document.documentElement.dataset.leSearchPage === 'true') {
    const url = new URL(window.location.href);
    const query = url.searchParams.get('q');
    if (query?.trim() && !isStructured(query)) {
      url.searchParams.set('q', build(query));
      url.searchParams.set('type', 'product');
      window.location.replace(url.href);
    }
  }
})();
